export default __webpack_public_path__ + "static/media/img_06.3b0282c5.jpg";